import {
  getManagedAbsenceUsers,
  UserAutocompleteField,
  useResourceUsers,
} from '@src/features/absence';
import { useAuthentication } from '@src/features/auth';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type UsersFieldProps = {
  disabled?: boolean;
};

export default function UsersField({ disabled = false }: UsersFieldProps) {
  const { user } = useAuthentication();
  const { users } = useResourceUsers();
  const availableUsers = useMemo(
    () => getManagedAbsenceUsers(users, user),
    [users, user],
  );

  const { t } = useTranslation();

  return (
    <UserAutocompleteField
      disabled={disabled}
      label={t('absence.schedule.field_for', 'For')}
      name="userId"
      users={availableUsers}
      size="large"
      required
    />
  );
}
